import {
  getIcon,
  ImageSearchResultCard,
  LinkSearchResultCard,
} from '@monash/portal-frontend-common';
import { Card } from '@monash/portal-react';
import { useStoreValue } from '@longsien/react-store';
import c from './preview-link-card.module.scss';
import classNames from 'classnames';
import { useWatch } from 'react-hook-form';
import { categoriesStore } from '../../shared/stores';
import { LINK_TYPES } from '../constants';

const resolveCategoryNames = (formCategories, allCategories) => {
  const titleById = Object.fromEntries(
    allCategories?.map(({ id, title }) => [id, title]) ?? []
  );

  return (formCategories ?? [])
    .map((category) => titleById[category.id])
    .filter(Boolean);
};

const PreviewLinkCard = () => {
  const allCategories = useStoreValue(categoriesStore);

  const [
    linkType,
    name,
    description,
    icon,
    categories,
    imageUrl,
    displayLabel,
  ] = useWatch({
    name: [
      'linkType',
      'name',
      'description',
      'icon',
      'categories',
      'imageUrl',
      'displayLabel',
    ],
  });

  const isServiceOrExperience = [
    LINK_TYPES.SERVICE,
    LINK_TYPES.EXPERIENCE,
  ].includes(linkType);

  const isEmpty = isServiceOrExperience
    ? !name && !description && !imageUrl
    : !icon && !name && !description;

  const categoryNames = resolveCategoryNames(categories, allCategories);

  if (isEmpty) {
    return (
      <Card className={c.card}>
        <div className={classNames(c.skeleton, c.icon)} />
        <div className={classNames(c.skeleton, c.name)} />
        <div className={classNames(c.skeleton, c.desc)} />
      </Card>
    );
  }

  if (isServiceOrExperience) {
    return (
      <ImageSearchResultCard
        linkType={linkType}
        name={name}
        description={description}
        displayLabel={displayLabel}
        categoryNames={categoryNames}
        imageUrl={imageUrl || undefined}
        className={c.card}
      />
    );
  }

  return (
    <LinkSearchResultCard
      linkType={linkType ?? LINK_TYPES.LINK}
      name={name}
      description={description}
      icon={icon ? getIcon(icon) : undefined}
      categoryNames={categoryNames}
      className={c.card}
    />
  );
};

export default PreviewLinkCard;
